/*
 * @Description: 短信配置
 * @Author: pu.yuchun
 * @LastEditors: pu.yuchun
 * @Date: 2019-06-06 14:48:39
 * @LastEditTime: 2019-06-06 23:26:50
 */
'use strict';
angular
    .module('smsMgrModule', ['smsManageServiceModule'])
    .controller('smsMgrCtrl', [
        '$scope',
        'smsManageService',
        'httpService',
        '$filter',
        'modalDialog',
        'trsspliceString',
        '$q',
        function(
            $scope,
            smsManageService,
            httpService,
            $filter,
            modalDialog,
            trsspliceString,
            $q
        ) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.data = {
                    listData: []
                };
            }
            /**
             * 初始化数据
             */
            function initData() {
                requestData();
            }
            /**
             * 请求列表数据
             */
            function requestData() {
                var params = {};
                $scope.loadingPromise = httpService
                    .http(
                        '/mcnadmin/admin/mobileSms/findAll.do',
                        params,
                        'post'
                    )
                    .then(function(data) {
                        $scope.data.listData = data.data;
                    });
            }
            /**
             * 新建短信配置
             * isCreate: 新建true 编辑 false
             * id: 短信id
             */
            $scope.creatSMS = function(isCreate, id) {
                smsManageService.createSMS(isCreate, id).then(function(data) {
                    $scope.loadingPromise = httpService
                        .http('/mcnadmin/admin/mobileSms/save.do', data, 'post')
                        .then(function(data) {
                            var txt = '';
                            isCreate
                                ? (txt = '新建短信配置成功')
                                : (txt = '编辑短信配置成功');
                            modalDialog.alertType('', txt, 'success');
                            requestData();
                        });
                });
            };
            /**
             * 设置为默认短信
             * id 短信对应id
             */
            $scope.setDefault = function(id) {
                modalDialog.backConfirmModal(
                    '设置默认配置',
                    '确认设置当前选中的短信配置为默认发送方式?',
                    function() {
                        var params = {
                            mobileSmsId: id
                        };
                        httpService
                            .http(
                                '/mcnadmin/admin/mobileSms/changeDefault.do',
                                params,
                                'post'
                            )
                            .then(function(data) {
                                modalDialog.alertType(
                                    '',
                                    '设置成功',
                                    'success'
                                );
                                requestData();
                            });
                    }
                );
            };
            /**
             * 删除短信配置
             * id 短信对应id
             */
            $scope.deletesms = function(id) {
                modalDialog.backConfirmModal(
                    '删除短信配置',
                    '确认删除当前选中的短信配置?',
                    function() {
                        var params = {
                            mobileSmsId: id
                        };
                        httpService
                            .http(
                                '/mcnadmin/admin/mobileSms/delete.do',
                                params,
                                'post'
                            )
                            .then(function(data) {
                                modalDialog.alertType(
                                    '',
                                    '删除成功',
                                    'success'
                                );
                                requestData();
                            });
                    }
                );
            };
        }
    ]);
